/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { aiIntegrationsUpsertAnthropicInferenceConfig } from "../funcs/aiIntegrationsUpsertAnthropicInferenceConfig.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AnthropicInferenceConfig } from "../models/components/anthropicinferenceconfig.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpsertAnthropicInferenceConfigRequest,
  UpsertAnthropicInferenceConfigSecurity,
} from "../models/operations/upsertanthropicinferenceconfig.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpsertAnthropicInferenceConfigMutationVariables = {
  request: UpsertAnthropicInferenceConfigRequest;
  security?: UpsertAnthropicInferenceConfigSecurity | undefined;
  options?: RequestOptions;
};

export type UpsertAnthropicInferenceConfigMutationData =
  AnthropicInferenceConfig;

export type UpsertAnthropicInferenceConfigMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * upsertAnthropicInferenceConfig aiIntegrations
 *
 * @remarks
 * Prepare a webhook URL or update its signing secret and enabled state.
 */
export function useUpsertAnthropicInferenceConfigMutation(
  options?: MutationHookOptions<
    UpsertAnthropicInferenceConfigMutationData,
    UpsertAnthropicInferenceConfigMutationError,
    UpsertAnthropicInferenceConfigMutationVariables
  >,
): UseMutationResult<
  UpsertAnthropicInferenceConfigMutationData,
  UpsertAnthropicInferenceConfigMutationError,
  UpsertAnthropicInferenceConfigMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpsertAnthropicInferenceConfigMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpsertAnthropicInferenceConfig(): MutationKey {
  return ["@gram/client", "aiIntegrations", "upsertAnthropicInferenceConfig"];
}

export function buildUpsertAnthropicInferenceConfigMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpsertAnthropicInferenceConfigMutationVariables,
  ) => Promise<UpsertAnthropicInferenceConfigMutationData>;
} {
  return {
    mutationKey: mutationKeyUpsertAnthropicInferenceConfig(),
    mutationFn: function upsertAnthropicInferenceConfigMutationFn({
      request,
      security,
      options,
    }): Promise<UpsertAnthropicInferenceConfigMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(aiIntegrationsUpsertAnthropicInferenceConfig(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
